<template lang="pug">
footer.v-page-footer.page-footer(v-if="footer" )
	.container.page-footer__wrap
		.page-footer__layout
			template(v-for="(item, index) in footer.items" :key="index")
				.page-footer__cell
					.page-footer__block.flc
						template(v-if="item.title && item.title.href && item.title.text" )
							a.page-footer__block-title.h5.flc(:href="item.title.href") {{item.title.text}}
						template(v-else-if="item.title && item.title.text")
							.page-footer__block-title.h5.flc {{item.title.text}}
						.page-footer__block-body.flc
							ul.page-footer-menu
								template(v-for="(itemLvl2, indexLvl2) in item.items" :key="indexLvl2")
									li.page-footer-menu__item
										a.page-footer-menu__link(:href="itemLvl2.href") {{itemLvl2.text}}
		.page-footer__aside(v-if="footer.aside" )
			slot(name="footer-icons" )
			.page-footer__select
				v-field(
					v-model="footer.aside.field.value"
					:field="footer.aside.field")
	.page-subfooter(v-if="footer.subfooter" )
		.container
			.page-subfooter__layout
				.page-subfooter__left
					a.page-subfooter__title(
							v-if="footer.subfooter.title"
							:href="footer.subfooter.title?.href")
						|{{ footer.subfooter.title?.text }}
					slot(name="subfooter-icons" )
				.page-subfooter__spacer
				.page-subfooter__right(v-if="footer.subfooter.link" )
					a.page-subfooter__right-link(
							:href="footer.subfooter.link.href"
							target="blank")
						|{{ footer.subfooter.link?.text }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import observer from "../scripts/helpers/observer.js";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			footer: null,
		};
	},

	methods: {
		dataSet(data) {
			this.footer = data;

			this.$nextTick(() => {
				const footer = document.querySelector('.page-footer');
				observer({threshold: 0, rootMargin: '0px 0px 200px 0px',}).observe(footer)
			})
		}
	},
};
</script>
